import { render, staticRenderFns } from "./productDetailsNoReview.html?vue&type=template&id=0a703280&scoped=true&"
import script from "./productDetailsNoReview.vue?vue&type=script&lang=js&"
export * from "./productDetailsNoReview.vue?vue&type=script&lang=js&"
import style0 from "./productDetailsNoReview.vue?vue&type=style&index=0&id=0a703280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a703280",
  null
  
)

export default component.exports